import React, { useState, useEffect } from 'react';
import Nav from '../components/Nav';

export default function MobileTest() {
  const [screenInfo, setScreenInfo] = useState({
    width: 0,
    height: 0,
    orientation: '',
    isMobile: false
  });

  useEffect(() => {
    const updateScreenInfo = () => {
      setScreenInfo({
        width: window.innerWidth,
        height: window.innerHeight,
        orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait',
        isMobile: window.innerWidth <= 768
      });
    };

    updateScreenInfo();
    window.addEventListener('resize', updateScreenInfo);
    window.addEventListener('orientationchange', updateScreenInfo);

    return () => {
      window.removeEventListener('resize', updateScreenInfo);
      window.removeEventListener('orientationchange', updateScreenInfo);
    };
  }, []);

  return (
    <div>
      <Nav />
      <div style={{ padding: '20px' }}>
        <h1>Mobile Navigation Test</h1>
        <p>This page helps test the mobile navigation.</p>
        
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
          <h2>🔍 Real-time Debug Info:</h2>
          <p><strong>Screen Width:</strong> {screenInfo.width}px</p>
          <p><strong>Screen Height:</strong> {screenInfo.height}px</p>
          <p><strong>Orientation:</strong> {screenInfo.orientation}</p>
          <p><strong>Is Mobile (≤768px):</strong> {screenInfo.isMobile ? '✅ YES' : '❌ NO'}</p>
          <p><strong>Should Show Hamburger:</strong> {screenInfo.isMobile ? '✅ YES' : '❌ NO'}</p>
        </div>
        
        <div style={{ marginTop: '20px' }}>
          <h2>Test Instructions:</h2>
          <ol>
            <li>Resize your browser to mobile width (768px or less)</li>
            <li>Look for the hamburger menu (3 lines) in the top right</li>
            <li>Click the hamburger menu to open the navigation</li>
            <li>Check if the navigation appears as a full-screen overlay</li>
            <li>Test clicking on navigation links</li>
            <li>Try rotating your device to test both orientations</li>
          </ol>
        </div>

        <div style={{ marginTop: '20px' }}>
          <h2>Navigation Links:</h2>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/chefs">Meet Local Chefs</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/dashboard">Dashboard</a></li>
            <li><a href="/login">Login</a></li>
          </ul>
        </div>

        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
          <h3>⚠️ Troubleshooting:</h3>
          <p>If you don't see the hamburger menu:</p>
          <ul>
            <li>Make sure your screen width is ≤ 768px</li>
            <li>Try refreshing the page</li>
            <li>Check if there are any JavaScript errors in the browser console</li>
            <li>Try rotating your device to see if it appears in landscape mode</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
